export default __webpack_public_path__ + "95dfff662d5eb0041227977caae661f4.png";